<section class="template-container p-1">
  <!--   <div class="card template-item" *ngIf="template as template">
    <div class="card-body">
      <section>
        <div *ngIf="template.header" class="header-container">
          <img
            *ngIf="template.header_type === headerType.IMAGE"
            [src]="parameterizedComponents.header"
            alt="Link de encabezado"
            class="image-template"
          />
          <i
            *ngIf="isHeaderMultimedia()"
            class="link-icon fa-solid fa-link"
          ></i>

          <div *ngIf="template.header_type === headerType.TEXT">
            <div class="header-template">
              <span [innerHTML]="parameterizedComponents.header"></span>
            </div>
          </div>
        </div>

        <div *ngIf="template.body">
          <div class="body-template">
            <p [innerHTML]="parameterizedComponents.body"></p>
          </div>
        </div>

        <div *ngIf="template.footer">
          <div class="footer-template text-muted">
            {{ template.footer }}
          </div>
        </div>

        <div *ngIf="template.buttons">
          <hr />
          <div class="buttons-template">
            <button
              *ngFor="let button of template.buttons.options"
              class="btn btn-outline-primary btn-sm mr-1"
            >
              {{ button.title }}
            </button>
          </div>
        </div>
      </section>
    </div>
  </div> -->

  <div
    class="card card-transaction template template-container"
    *ngIf="template as template"
  >
    <!-- Header -->

    <div *ngIf="template.header" class="p-1" style="padding-bottom: 0px !important;">
      <a [href]="mediaLink" target="_blank" class="pd-4" *ngIf="template.header_type === headerType.IMAGE || template.header_type === headerType.DOCUMENT">
        <img
          *ngIf="template.header_type === headerType.IMAGE || template.header_type === headerType.DOCUMENT"
          [src]="parameterizedComponents?.header"
          alt="Header multimedia"
          class="header-image"
        />
        <i
          data-toggle="tooltip"
          data-container="body"
          data-placement="top"
          title="Multimedia"
          *ngIf="isHeaderMultimedia()"
          class="link-icon fa-solid fa-link"
        ></i>
      </a>
      <h5
        *ngIf="template.header_type === headerType.TEXT"
        class="card-title"
        [innerHTML]="parameterizedComponents?.header | sanitizeHTML"
      ></h5>
      <video *ngIf="template.header_type === headerType.VIDEO && parameterizedComponents.header" class="header-image" controls>
        <source [src]="parameterizedComponents?.header" type="video/mp4">
      </video>
    </div>
    <!-- Body -->
    <div class="card-body">
      <p
        *ngIf="template.body"
        [innerHTML]="parameterizedComponents.body"
        style="color: #565656 !important"
      ></p>
      <!-- Footer -->
      <span *ngIf="template.footer" class="m-footer">{{
        template.footer
      }}</span>
    </div>
    <!-- Buttons -->
    <div class="card-footer" *ngIf="template.buttons">
      <div *ngFor="let button of template.buttons.options; let isFirst = first">
        <a
          class="btn-template"
          [class.borderTopNone]="isFirst"
          href="javascript:void(0)"
        >
          <i class="feather feather-corner-up-left"></i>{{ button.title }}
        </a>
      </div>
    </div>
  </div>
</section>
